import React, { useState } from "react";
import PWAHeader from "../common/PWAHeader";
import DatePickerRow from "../common/DatePickerRow";


const Fsn52LogMeditations = ({ onTap }) => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [currentWeek, setCurrentWeek] = useState(0);

  return (
    <div className="App">
      <PWAHeader title={onTap?.FAI?.title || "Log Meditation"} />
      <DatePickerRow
          selectedDate={selectedDate}
          onDateSelect={setSelectedDate}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
          restrictPastDates={false}  // Restrict past dates for appointment booking
          restrictFutureDates={true} // Allow future dates
        />
    </div>
  );
};

export default Fsn52LogMeditations;